import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ILoginRequest } from '../pages/login/login.interface';

type SigninResponse = {
  accessToken: string;
  refreshToken: string;
};

type IdpTokenResponse = {
  access_token: string;
  refresh_token: string;
};
@Injectable({
  providedIn: 'root',
})
export class LoginV2Service {
  url = environment.api_v2;

  constructor(private readonly http: HttpClient) {}

  public signin(body: ILoginRequest): Observable<SigninResponse> {
    return this.http.post<SigninResponse>(`${this.url}/v2/auth`, body);
  }

  public signinWithIdp(body: ILoginRequest): Observable<SigninResponse> {
    const base = environment.idpApiUrl;
    if (!base) {
      throw new Error('IDP API URL is not configured for this environment');
    }
    return this.http
      .post<IdpTokenResponse>(`${base}/api/auth/token`, {
        username: body.user,
        password: body.password,
      })
      .pipe(
        map((res) => ({
          accessToken: res.access_token,
          refreshToken: res.refresh_token,
        }))
      );
  }
}
